import { render, staticRenderFns } from "./TrangSuaCapDonVi.vue?vue&type=template&id=14e36675&"
import script from "./TrangSuaCapDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangSuaCapDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports